module.exports = __webpack_public_path__ + "img/accounts.daily.73ee2c6d.png";